//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'
import viewRelateFlow from '@/components/browse/view-relate-flow'


export default {
  name: "leave-message-check",
  components: {
    fileUpload,
    DivSpan,
    viewRelateFlow
  },
  props: ['dataId','dataImg'],
  data() {
    return {
      baseDto: {},
      list: [],
      index: 1,
      bigImg:false,
      gridList: [
        {icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'基本信息'},
        {icon:require('@/assets/icon/supplier/com_order_flow.png'),label:'流程信息'},
      ],
    }
  },
  methods: {
    itemTab(index) {
      this.index = index;
      if(index === 2){
        this.$emit('changeFlowInfo',true);
      }else{
        this.$emit('changeFlowInfo',false);
      }
    },
    getBaseDto() {
      this.$loadingShow();
      this.$get('api/leave-message/' + this.dataId).then((data) => {
        this.baseDto = data;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    }

  },
  mounted() {
    if (this.dataId) {
      this.getBaseDto()
    }
  },
  watch: {
    dataId() {
      if (this.dataId) {
        this.getBaseDto()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/leave-message/leave-message-check.vue